import { useState } from 'react';
import Layout from '../components/Layout';
import client from '../api/client';

export default function ShoppingCompare() {
  const [myUrl, setMyUrl] = useState('');
  const [compUrl, setCompUrl] = useState('');
  const [keywordsText, setKeywordsText] = useState('');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const s: any = {
    card: { background: '#161B27', border: '0.5px solid #2A3045', borderRadius: 8, padding: 20, marginBottom: 16 },
    input: { width: '100%', background: '#0F1117', border: '0.5px solid #2A3045', borderRadius: 8, padding: '10px 14px', color: '#E8ECF4', fontSize: 13, boxSizing: 'border-box' as const },
    btn: { background: '#00D4AA', border: 'none', borderRadius: 8, padding: '10px 28px', color: '#0A1F18', fontSize: 14, fontWeight: 700, cursor: 'pointer' },
    label: { color: '#B0BAC8', fontSize: 12, marginBottom: 6, display: 'block' },
  };

  const handleCompare = async () => {
    const keywords = keywordsText.split('\n').map(k => k.trim()).filter(Boolean);
    if (!myUrl || !compUrl) return setError('두 상품 URL을 입력하세요');
    if (!keywords.length) return setError('키워드를 입력하세요');
    if (keywords.length > 7) return setError('키워드는 최대 7개');
    setLoading(true); setError(''); setResult(null);
    try {
      const res = await client.post('/shopping/compare', { my_url: myUrl, comp_url: compUrl, keywords });
      setResult(res.data);
    } catch (e: any) {
      setError(e.response?.data?.detail || '비교 실패');
    } finally { setLoading(false); }
  };

  const scoreColor = (s: number) => s >= 80 ? '#00D4AA' : s >= 60 ? '#F6AD55' : '#F56565';

  const SeoCard = ({ label, data, color }: any) => (
    <div style={{ background: '#0F1117', borderRadius: 8, padding: 16, flex: 1 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <span style={{ color, fontSize: 13, fontWeight: 700 }}>{label}</span>
        <div style={{ background: '#161B27', borderRadius: 20, padding: '4px 14px', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ color: scoreColor(data.score), fontSize: 20, fontWeight: 900 }}>{data.score}</span>
          <span style={{ color: '#4A5568', fontSize: 11 }}>점</span>
        </div>
      </div>
      <div style={{ color: '#8892A4', fontSize: 12, marginBottom: 8 }}>상품명 {data.length}자</div>
      {data.goods?.map((g: string, i: number) => (
        <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
          <span style={{ color: '#00D4AA', fontSize: 11 }}>✓</span>
          <span style={{ color: '#8892A4', fontSize: 11 }}>{g}</span>
        </div>
      ))}
      {data.issues?.map((issue: string, i: number) => (
        <div key={i} style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
          <span style={{ color: '#F56565', fontSize: 11 }}>✗</span>
          <span style={{ color: '#F56565', fontSize: 11 }}>{issue}</span>
        </div>
      ))}
    </div>
  );

  return (
    <Layout>
      <div style={{ maxWidth: 900 }}>
        <div style={{ marginBottom: 20 }}>
          <h2 style={{ color: '#E8ECF4', fontSize: 16, fontWeight: 500, margin: '0 0 4px' }}>쇼핑 경쟁사 비교</h2>
          <p style={{ color: '#8892A4', fontSize: 12, margin: 0 }}>키워드 순위와 상품명 SEO를 경쟁사와 비교합니다</p>
        </div>

        <div style={s.card}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ ...s.label, color: '#00D4AA' }}>⭐ 내 상품 URL</label>
              <input style={s.input} value={myUrl} onChange={e => setMyUrl(e.target.value)}
                placeholder="https://smartstore.naver.com/..." />
            </div>
            <div>
              <label style={s.label}>경쟁사 상품 URL</label>
              <input style={s.input} value={compUrl} onChange={e => setCompUrl(e.target.value)}
                placeholder="https://smartstore.naver.com/..." />
            </div>
          </div>
          <label style={s.label}>비교 키워드 (줄바꿈으로 구분, 최대 7개)</label>
          <textarea style={{ ...s.input, height: 120, resize: 'vertical' as const, marginBottom: 16 }}
            value={keywordsText} onChange={e => setKeywordsText(e.target.value)}
            placeholder={"마라톤양말\n런닝양말\n논슬립양말"} />
          {error && <p style={{ color: '#F56565', fontSize: 13, marginBottom: 12 }}>{error}</p>}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button style={s.btn} onClick={handleCompare} disabled={loading}>
              {loading ? '비교 중...' : '비교 시작'}
            </button>
            {loading && <span style={{ color: '#8892A4', fontSize: 12 }}>키워드당 약 2초 소요됩니다...</span>}
          </div>
        </div>

        {result && (
          <>
            {/* 순위 요약 */}
            <div style={{ ...s.card, display: 'flex', gap: 20, alignItems: 'center' }}>
              <div style={{ flex: 1, textAlign: 'center' as const }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: '#00D4AA' }}>{result.summary.my_wins}</div>
                <div style={{ color: '#8892A4', fontSize: 12 }}>내가 앞선 키워드</div>
              </div>
              <div style={{ flex: 1, textAlign: 'center' as const }}>
                <div style={{ fontSize: 36, fontWeight: 900, color: '#F56565' }}>{result.summary.comp_wins}</div>
                <div style={{ color: '#8892A4', fontSize: 12 }}>경쟁사가 앞선 키워드</div>
              </div>
              <div style={{ flex: 2, background: '#0F1117', borderRadius: 8, padding: '12px 16px' }}>
                <div style={{ display: 'flex', height: 12, borderRadius: 6, overflow: 'hidden', marginBottom: 6 }}>
                  <div style={{ width: `${result.summary.total ? (result.summary.my_wins/result.summary.total*100) : 0}%`, background: '#00D4AA', transition: 'width 0.5s' }} />
                  <div style={{ flex: 1, background: '#F56565' }} />
                </div>
                <div style={{ color: '#8892A4', fontSize: 11 }}>
                  내 상품 우위: {result.summary.total ? Math.round(result.summary.my_wins/result.summary.total*100) : 0}%
                </div>
              </div>
            </div>

            {/* SEO 비교 */}
            <div style={s.card}>
              <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 700, marginBottom: 16 }}>상품명 SEO 분석</div>
              <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                <SeoCard label="⭐ 내 상품" data={result.my.seo} color="#00D4AA" />
                <SeoCard label="경쟁사" data={result.comp.seo} color="#8892A4" />
              </div>
              <div style={{ background: '#0F1117', borderRadius: 8, padding: 12 }}>
                <div style={{ color: '#8892A4', fontSize: 11, marginBottom: 8 }}>상품명 비교</div>
                <div style={{ marginBottom: 6 }}>
                  <span style={{ color: '#00D4AA', fontSize: 11 }}>내 상품: </span>
                  <span style={{ color: '#E8ECF4', fontSize: 12 }}>{result.my.name}</span>
                </div>
                <div>
                  <span style={{ color: '#8892A4', fontSize: 11 }}>경쟁사: </span>
                  <span style={{ color: '#E8ECF4', fontSize: 12 }}>{result.comp.name}</span>
                </div>
              </div>
            </div>

            {/* 키워드별 순위 */}
            <div style={s.card}>
              <div style={{ color: '#E8ECF4', fontSize: 14, fontWeight: 700, marginBottom: 16 }}>키워드별 순위 비교</div>
              <table style={{ width: '100%', borderCollapse: 'collapse' as const }}>
                <thead>
                  <tr style={{ background: '#1A2035' }}>
                    {['키워드', '내 상품', '경쟁사', '결과'].map(h => (
                      <th key={h} style={{ padding: '10px 14px', color: '#8892A4', fontSize: 11, textAlign: 'left' as const }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {result.rank_results?.map((r: any, i: number) => (
                    <tr key={i} style={{ borderBottom: '0.5px solid #1E2535' }}>
                      <td style={{ padding: '10px 14px', color: '#E8ECF4', fontSize: 13 }}>{r.keyword}</td>
                      {r.error ? (
                        <td colSpan={3} style={{ padding: '10px 14px', color: '#F56565', fontSize: 12 }}>오류</td>
                      ) : (
                        <>
                          <td style={{ padding: '10px 14px' }}>
                            <span style={{ color: r.my_better ? '#00D4AA' : '#E8ECF4', fontSize: 14, fontWeight: 700 }}>
                              {r.my.rank ? `${r.my.page}p ${r.my.rank}위` : '순위 밖'}
                            </span>
                          </td>
                          <td style={{ padding: '10px 14px' }}>
                            <span style={{ color: !r.my_better ? '#F56565' : '#8892A4', fontSize: 14, fontWeight: 700 }}>
                              {r.comp.rank ? `${r.comp.page}p ${r.comp.rank}위` : '순위 밖'}
                            </span>
                          </td>
                          <td style={{ padding: '10px 14px' }}>
                            {r.my_better ? (
                              <span style={{ background: '#00D4AA22', border: '1px solid #00D4AA55', borderRadius: 4, padding: '2px 8px', color: '#00D4AA', fontSize: 11 }}>✅ 내가 앞섬</span>
                            ) : (
                              <span style={{ background: '#F5656522', border: '1px solid #F5656555', borderRadius: 4, padding: '2px 8px', color: '#F56565', fontSize: 11 }}>❌ 경쟁사 앞섬</span>
                            )}
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}
